/*
 * marketing-utm.js — semnalele de marketing pentru formularele proprii.
 *
 * De ce exista: formularul de programare produce ~jumatate din leaduri, dar pana
 * acum trimitea doar datele omului, fara sa spuna de unde a venit. Atribuirea se
 * facea prin pixel, care rateaza aproximativ jumatate din oameni (blocante, iOS,
 * consimtamant). Parametrii UTM sunt insa chiar in URL-ul cu care a aterizat omul.
 *
 * Persistenta e obligatorie, nu optionala: cazul obisnuit e aterizarea pe o pagina
 * de oferta cu UTM-uri, apoi navigarea catre pagina de programare, unde parametrii
 * nu mai exista in URL. Retinem deci PRIMA atingere, 60 de zile.
 *
 * Refolosim cookie-urile puse deja de Custom Web Pixel (`fl_utm`, `fl_src`), cu
 * acelasi format, ca sa nu existe doua adevaruri despre aceeasi vizita. Cand
 * pixelul e blocat, le scriem noi — de aici vine castigul de acoperire.
 *
 * Expune window.flrMarketing.get() -> { utm_source, utm_medium, utm_campaign,
 * utm_content, utm_term, referrer }.
 */
(function () {
  if (window.flrMarketing) return;

  var UTM_COOKIE = 'fl_utm';   // first-touch UTM (JSON), pus si de pixel
  var SRC_COOKIE = 'fl_src';   // first-touch source (brut), pus si de pixel
  var REF_COOKIE = 'fl_ref';   // first-touch referrer (doar al nostru)
  var MAX_AGE = 60 * 60 * 24 * 60; // 60 zile

  var OWN_HOSTS = ['florentinodelure.com', 'florentinodelure.ro'];

  function getCookie(name) {
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      var eq = p.indexOf('=');
      if (eq > 0 && p.slice(0, eq) === name) {
        try { return decodeURIComponent(p.slice(eq + 1)); } catch (e) { return p.slice(eq + 1); }
      }
    }
    return null;
  }

  function setCookie(name, value) {
    try {
      document.cookie = name + '=' + encodeURIComponent(value) +
        '; Max-Age=' + MAX_AGE + '; Path=/; SameSite=Lax';
    } catch (e) { /* cookie-uri blocate: mergem mai departe fara persistenta */ }
  }

  function safeJson(s) { try { return JSON.parse(s); } catch (e) { return null; } }

  // Cheile scurte sunt cele scrise de pixel; le pastram identice.
  function utmFromUrl() {
    var out = {};
    try {
      var params = new URL(window.location.href).searchParams;
      var map = { utm_source: 'source', utm_medium: 'medium', utm_campaign: 'campaign',
                  utm_content: 'content', utm_term: 'term' };
      for (var k in map) {
        var v = params.get(k);
        if (v) out[map[k]] = v;
      }
    } catch (e) { /* URL nesuportat: ramane gol */ }
    return out;
  }

  // Un referrer de pe propriul site e navigare interna, nu sursa.
  function externalReferrer() {
    var ref = document.referrer || '';
    if (!ref) return '';
    try {
      var host = new URL(ref).hostname.toLowerCase();
      for (var i = 0; i < OWN_HOSTS.length; i++) {
        var own = OWN_HOSTS[i];
        if (host === own || host.slice(-(own.length + 1)) === '.' + own) return '';
      }
      return ref;
    } catch (e) { return ''; }
  }

  // Prima atingere castiga: daca exista deja cookie, nu-l suprascriem niciodata.
  function capture() {
    var stored = safeJson(getCookie(UTM_COOKIE));
    var hasStored = stored && (stored.source || stored.medium || stored.campaign);

    if (!hasStored) {
      var fresh = utmFromUrl();
      if (fresh.source || fresh.medium || fresh.campaign) {
        setCookie(UTM_COOKIE, JSON.stringify(fresh));
        if (fresh.source) setCookie(SRC_COOKIE, fresh.source);
        stored = fresh;
      }
    }

    if (!getCookie(REF_COOKIE)) {
      var ref = externalReferrer();
      if (ref) setCookie(REF_COOKIE, ref);
    }

    return stored || {};
  }

  var captured = capture();

  window.flrMarketing = {
    get: function () {
      return {
        utm_source: captured.source || '',
        utm_medium: captured.medium || '',
        utm_campaign: captured.campaign || '',
        utm_content: captured.content || '',
        utm_term: captured.term || '',
        referrer: getCookie(REF_COOKIE) || externalReferrer() || ''
      };
    }
  };
})();
